import { render, staticRenderFns } from "./Ventilation.vue?vue&type=template&id=36170d87&scoped=true&"
import script from "./Ventilation.vue?vue&type=script&lang=js&"
export * from "./Ventilation.vue?vue&type=script&lang=js&"
import style0 from "./Ventilation.vue?vue&type=style&index=0&id=36170d87&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36170d87",
  null
  
)

export default component.exports